declare namespace $ {

	export class $mol_icon_form_textarea extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=textarea.view.tree.d.ts.map